module.exports = __webpack_public_path__ + "static/img/rgt-ss.c19ca7c2.png";